import { styled, css } from '@mui/material/styles';
import {
  enterDurationMs,
  enterEasing,
  listStaggerStepMs,
  slideInFromRight,
} from 'core/common/ui/ui-kit/motion';
import { ListLayoutVariant } from 'core/flow/entities';
import { AnimationTypes } from './types';

const gridColumnsCount = 3;
const gridGapPx = 16;

export const AnswerListItemStyled = styled('li')<{
  $isAnimate: boolean;
  $index: number;
  $animationVariant: AnimationTypes;
}>(
  ({ $animationVariant, $isAnimate, $index }) => css`
    height: 100%;
    visibility: hidden;

    ${
      $animationVariant === AnimationTypes.FADE_SLIDE &&
      css`
        opacity: ${$isAnimate ? 0 : 1};
        animation: ${$isAnimate ? slideInFromRight : 'none'} ${enterDurationMs}ms ${enterEasing}
          ${$index * listStaggerStepMs}ms forwards;
      `
    }
  `,
);

export const AnswerListStyled = styled('ul')<{ layoutVariant: ListLayoutVariant; mt?: number }>`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(3)};
  margin-top: ${({ theme, mt }) => (mt ? theme.spacing(mt) : 0)};

  ${({ layoutVariant }) => {
    if (layoutVariant === ListLayoutVariant.TILE) {
      return 'justify-content: space-between;';
    }
  }}

  ${({ layoutVariant }) => {
    if (layoutVariant === ListLayoutVariant.GRID) {
      return `gap: ${gridGapPx}px;`;
    }
  }}

  li {
    ${({ layoutVariant }) => {
      if (layoutVariant === ListLayoutVariant.COLUMN) {
        return `width: 100%;`;
      }
      if (layoutVariant === ListLayoutVariant.TILE) {
        return `width: calc(50% - 6px);`;
      }
      if (layoutVariant === ListLayoutVariant.GRID) {
        return `width: calc((100% - ${gridGapPx * (gridColumnsCount - 1)}px) / ${gridColumnsCount});`;
      }
      return `width: auto;`;
    }}
  }
`;
